import { StatePlaceholder } from '../../../cdl/StatePlaceholder/StatePlaceholder';
import { translate } from '../../helpers/translate.helper';
import { IconAlertTriangle } from '../../icons/cdl/AlertTriangle';
import { Box } from '../../ui/Box';

interface CommandErrorStateProps {
    title?: string;
    description?: string;
}

export const CommandErrorState = ({
    title = translate('shortcutMenu.error.title'),
    description = translate('shortcutMenu.error.description'),
}: CommandErrorStateProps) => {
    return (
        <Box display="flex" justifyContent="center">
            <StatePlaceholder title={title} description={description} Icon={IconAlertTriangle} />
        </Box>
    );
};
